import onDomReady from './onDomReady';

function debounce(fn, delay, immediate) {
	let timeout;
	return function (...args) {
		const context = this;
		const later = () => {
			timeout = null;
			if (!immediate) fn.apply(context, args);
		};
		const callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, delay);
		if (callNow) fn.apply(context, args);
	};
}

// Najde nejbližší číslo v poli
function closest(arr, num) {
	let curr = arr[0];
	let diff = Math.abs(num - curr);
	for (let val of arr) {
		let newdiff = Math.abs(num - val);
		if (newdiff < diff) {
			diff = newdiff;
			curr = val;
		}
	}
	return curr;
}

onDomReady(() => {
	const el = document.querySelector('.homepage-slider');
	if (!el)
		return console.error(
			'homepage-slider.js: .homepage-slider element not found',
		);
	const items_el = el.querySelector('.items');
	const items = Array.from(el.querySelectorAll('.slider-item'));
	const count = items.length;
	const dot_controls = document.querySelector('.slider-dot-controls');
	let actual = 1;
	let interval;

	showSlide(actual);

	dot_controls?.querySelectorAll('li').forEach((dot, index) => {
		dot.style.cursor = 'pointer';
		dot.addEventListener('click', () => {
			showSlide(index + 1);
			clearInterval(interval);
		});
	});

	function showSlide(i) {
		items.forEach(item => item.classList.remove('active'));
		dot_controls
			?.querySelectorAll('li')
			.forEach(dot => dot.classList.remove('active'));
		items[i - 1]?.classList.add('active');
		dot_controls
			?.querySelector(`li:nth-child(${i})`)
			?.classList.add('active');
	}

	function nextSlide() {
		actual = (actual % count) + 1;
		showSlide(actual);
	}

	function prevSlide() {
		actual = ((actual - 2 + count) % count) + 1;
		showSlide(actual);
	}

	function play() {
		interval = setInterval(nextSlide, 6000);
	}

	items.forEach(item => {
		const href = item.getAttribute('data-href');
		if (href) {
			item.style.cursor = 'pointer';
			item.addEventListener('click', () => {
				window.location.href = href;
			});
		}
	});

	function slide_sizes() {
		let l = Math.max(window.innerWidth, window.innerHeight);
		items.forEach(item => {
			const ps = item.getAttribute('data-pictures');
			if (ps) {
				const s = ps.split(';');
				const ar = {};
				const sizes = [];
				s.forEach(entry => {
					const [size, url] = entry.split(':');
					ar[size] = url;
					sizes.push(parseInt(size, 10));
				});
				item.style.backgroundImage = `url(${ar[closest(sizes, l)]})`;
			}
		});
	}

	function slidePosition() {
		const scrollPosition = window.scrollY;
		const windowHeight = window.innerHeight;
		let opacity = (scrollPosition / windowHeight) * 1.4;
		opacity = Math.min(Math.max(opacity, 0), 1);
		const p = Math.round(-scrollPosition * 0.7);

		const sliderVisible = scrollPosition <= windowHeight;

		if (sliderVisible) {
			const transformValue = `translate3d(0, ${
				window.innerHeight < window.innerWidth ||
				window.innerWidth > 1024
					? p
					: -p
			}px, -1px)`;
			Object.assign(items_el.style, {
				display: 'block',
				position:
					window.innerHeight < window.innerWidth ||
					window.innerWidth > 1024
						? 'fixed'
						: 'absolute',
				transform: transformValue,
			});
			document
				.querySelectorAll('.homepage-slider-title, .slider-scroll-down')
				.forEach(el => {
					el.style.opacity = 1 - opacity;
				});
		} else {
			items_el.style.display = 'none'; // 👈 schovej ho mimo záběr
		}
	}

	function sliderPadding() {
		const header = document.querySelector('.master-padding');
		const slider_padding = document.querySelector(
			'.homepage-slider-padding',
		);
		const nh = window.innerHeight - (header?.offsetHeight || 0);

		if (
			window.innerHeight < window.innerWidth ||
			window.innerWidth > 1024
		) {
			slider_padding && (slider_padding.style.height = nh + 'px');
			el.style.height = nh + 'px';
			el.style.top = (header?.offsetHeight || 0) + 'px';
		} else {
			slider_padding?.removeAttribute('style');
			el.removeAttribute('style');
		}
	}

	window.addEventListener(
		'resize',
		debounce(() => {
			slide_sizes();
			sliderPadding();
			slidePosition();
		}, 200),
	);

	let ticking = false;

	window.addEventListener('scroll', () => {
		clearInterval(interval);
		if (!ticking) {
			window.requestAnimationFrame(() => {
				slidePosition();
				play();
				ticking = false;
			});
			ticking = true;
		}
	});

	sliderPadding();
	slidePosition();
	slide_sizes();
	play();

	document
		.querySelector('.slider-scroll-down')
		?.addEventListener('click', e => {
			e.preventDefault();
			window.scrollTo({
				top: el.offsetHeight,
				behavior: 'smooth',
			});
		});
});
